/**
 * Resolve a Salesforce user id (005…) from a login email using the generated RDS→display-name map.
 * Used when Keycloak does not expose SF user id but we need a graph traversal start key via {@link findGraphUserBySfId}.
 */

import sfUserMapping from '../config/sfUserMapping.generated.json';

function cleanEmail(value: string): string {
  return value.trim().toLowerCase();
}

/**
 * Returns SF user id (e.g. 0053u000002JDNBAA4) when the email matches exactly one mapped user name, else null.
 */
export function resolveSfUserIdFromEmail(email: string): string | null {
  const users = (sfUserMapping as { users?: Record<string, string> }).users ?? {};
  const norm = cleanEmail(email);
  if (!norm) return null;

  const displayName =
    users[norm] ||
    users[`${norm}.invalid`] ||
    users[`${norm}.cbaiv1`] ||
    users[`${norm}.cbaiv11`];
  if (!displayName) return null;

  const matches: string[] = [];
  for (const [k, v] of Object.entries(users)) {
    if (!k.startsWith('005') || k.length < 15) continue;
    if (v === displayName) matches.push(k);
  }
  if (matches.length !== 1) return null;
  return matches[0];
}
